import { openapiClient } from '@/api/openapi-client';
import { queryClient } from '@/api/query-client';
import { useI18nStore } from '@/i18n';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useEffect } from 'react';

export function useSyncUserLanguage(): void {
  const locale = useI18nStore((s) => s.locale);
  const localePending = useI18nStore((s) => s.localePending);
  const adoptLocale = useI18nStore((s) => s.adoptLocale);
  const markLocaleSynced = useI18nStore((s) => s.markLocaleSynced);
  const userContext = useRestaurantStore((s) => s.userContext);
  const setUserContext = useRestaurantStore((s) => s.setUserContext);

  useEffect(() => {
    if (!userContext) return;

    if (userContext.language === locale) {
      if (localePending) markLocaleSynced();
      return;
    }

    if (!localePending && userContext.language) {
      adoptLocale(userContext.language);
      return;
    }

    let cancelled = false;
    openapiClient
      .PATCH('/api/auth/me', { body: { language: locale } })
      .then((result) => {
        if (cancelled || !result.data) return;
        const synced = { ...userContext, language: result.data.language };
        queryClient.setQueryData(['auth', 'me'], synced);
        setUserContext(synced);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [locale, localePending, userContext, setUserContext, adoptLocale, markLocaleSynced]);
}
